export default "__VITE_ASSET__CHesUObv__"